import React from "react";

import OrganizationIdContext from "contexts/OrganizationIdContext";

/**
 * This hook return the ID of the organizer stored in the WidgetUUIDContext context.
 */
const useOrganizationId = () => {
  const context = React.useContext(OrganizationIdContext);

  if (context === undefined) {
    throw new Error("useOrganizationId must be used within a OrganizationIdContext");
  }

  return context;
};

export default useOrganizationId;
